import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { convertDateToHumanReadable, downloadFile, getMimeType } from "../../../helpers/Functions";
export default {
  name: "Messages.vue",
  components: {},
  data: function data() {
    return {};
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getLastTimeUpdated: function getLastTimeUpdated(value) {
      return convertDateToHumanReadable(value, true);
    },
    getAttachmentType: function getAttachmentType(attachment) {
      return getMimeType(attachment);
    },
    downloadAttachment: function downloadAttachment(attachment) {
      downloadFile(attachment);
    },
    renderTitle: function renderTitle(item) {
      var _item$user;

      var userName = (_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.name;
      /**
       * This label will be added if the message is sent by operator
       */

      if (item.sent_by_operator) {
        return userName + " | " + "پشتیبان فنی";
      }

      return userName;
    }
  },
  props: {
    messages: {
      type: Array,
      required: true
    }
  }
};